import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { postRequest } from '../../helpers/api';
import { CREATE_TICKET } from "../actions";
import { createTicketSuccess, createTicketError } from "./actions";
import NotificationManager from '../../components/common/react-notifications/NotificationManager';
const createTicketRequest = async ({ params }) => {
  return await new Promise((success, fail) => {
    setTimeout(() => {
      postRequest('/tickets', params)
        .then(response => response.json())
        .then(data => {
          success({ data });
        })
    })
  })
    .then(response => response)
    .catch(error => error);
};

function* createTicketFn(payload) {
  try {
    const response = yield call(createTicketRequest, payload);
    const { data } = response
    yield NotificationManager.success(`Ticket Id ${data.id} is created`, "", 4000, null, null, "filled");
    yield put(createTicketSuccess(data));
  } catch (error) {
    yield put(createTicketError(error));
  }
}

export function* watchGetList() {
  yield takeEvery(CREATE_TICKET, createTicketFn);
}

export default function* rootSaga() {
  yield all([fork(watchGetList)]);
}
